import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';
import Styles from './Existing.css';

class DeactivateConfirmModal extends Component {
  render() {
    return (
      <div>
        <Modal
          style={{ top: '120px' }}
          show={this.props.show}
          onHide={this._close}
          container={this}
          backdrop="static"
          dialogClassName={Styles['modal-dialog']}
        >
          <Modal.Header className={Styles['modal-header-danger']} closeButton>
            <Modal.Title style={{ fontSize: '19px', fontWeight: '300' }}>
              <div>Deactivate Loyalty Program?</div>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body
            className={`${Styles['modal-body']} top20 bottom20`}
            style={{ marginLeft: '20px' }}
          >
            Are you sure you want to deactivate your loyalty program? <br />
            <b>
              Your loyalty program will stop immediately and customers will not
              be
              <br />
              able to earn or redeem points.
            </b>
          </Modal.Body>
          <Modal.Footer>
            <button
              type="button"
              style={{ width: '100px' }}
              className="btn btn-default"
              onClick={this._close}
            >
              Cancel
            </button>
            <button
              type="button"
              style={{ width: '150px' }}
              className="btn btn-danger"
              onClick={this._onClickDeactivate}
            >
              Deactivate Program
            </button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }

  _close = e => {
    e.stopPropagation();
    this.props.close();
  };

  _onClickDeactivate = e => {
    e.stopPropagation();
    this.props.confirm();
  };
}

DeactivateConfirmModal.propTypes = {
  show: PropTypes.bool.isRequired,
  close: PropTypes.func.isRequired,
};

export default DeactivateConfirmModal;
